/**
 * This enum represents joi methods that are supported and tested for workflow configs.
 */
export enum JoiRule {
    MIN = 'min',
    MAX = 'max',
    GREATER = 'greater',
    LESS = 'less',
    ALPHAPNUM = 'alphanum',
    PATTERN = 'pattern',
    ISO = 'iso',
    INTEGER = 'integer',
    NEGATIVE = 'negative',
    POSITIVE = 'positive',
    GUID = 'guid'
}
